import { ProfileTab } from './types'

export const patientSummaryTab: ProfileTab = {
  path: 'patient',
  name: 'Patient',
}
export const insuranceInfoTab: ProfileTab = {
  path: 'insurance',
  name: 'Insurance Info',
}

export const consentFormTab: ProfileTab = {
  path: 'consent-forms',
  name: 'Consent Forms',
}

export const filesTab: ProfileTab = { path: 'files', name: 'Files' }

// export const visitsTab: ProfileTab = { path: 'visits', name: 'Visits' }
export const plansTab: ProfileTab = {
  path: 'plans',
  name: 'Insurance Plans',
}

export const labsTab: ProfileTab = {
  path: 'labs',
  name: 'Labs',
}
